<!-- The contacts side panel (Suppliers list, the header's global search): the detail-panel design.
     Fields save as they change, as they always have, so there's no edit mode or Save bar. -->
<div class="up-panel sc-panel" *ngIf="supplierTabMode; else legacyPanel">
  <ng-container *ngIf="currentPannel != panels.InvoiceDetailsTab">
    <div class="up-header">
      <app-supplier-avatar class="up-avatar sc-avatar" [ngClass]="supplier?.hexColorClass" [name]="supplier?.name" [logoUrl]="supplierLogoUrl"></app-supplier-avatar>
      <div class="up-header__text">
        <h2 class="up-header__name" [title]="supplier?.name || ''">{{ supplier?.name }}</h2>
        <span class="up-header__email">{{ contactSummary || 'Supplier' }}</span>
      </div>
      <div class="up-header__actions">
        <button type="button" class="sd-icon-btn" aria-label="Close" (click)="closeFormOnSupplier()">
          <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
            <path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
          </svg>
        </button>
      </div>
    </div>

    <nav class="up-tabs" role="tablist">
      <button type="button" role="tab" class="up-tab" [class.is-active]="currentPannel == panels.ExpensesTab"
              [attr.aria-selected]="currentPannel == panels.ExpensesTab" (click)="tabClick(panels.ExpensesTab)">
        Transactions
      </button>
      <button type="button" role="tab" class="up-tab" [class.is-active]="currentPannel == panels.DetailsTab"
              [attr.aria-selected]="currentPannel == panels.DetailsTab" (click)="tabClick(panels.DetailsTab)">
        Details
      </button>
      <button type="button" role="tab" class="up-tab" [class.is-active]="currentPannel == panels.ActivityTab"
              [attr.aria-selected]="currentPannel == panels.ActivityTab" (click)="tabClick(panels.ActivityTab)">
        Activity
      </button>
      <button type="button" role="tab" class="up-tab" [class.is-active]="currentPannel == panels.RelatedTab"
              [attr.aria-selected]="currentPannel == panels.RelatedTab" (click)="tabClick(panels.RelatedTab)">
        Related
      </button>
    </nav>
  </ng-container>

  <!-- ─── Details ─────────────────────────────────────────────────────────── -->
  <section class="up-body" *ngIf="currentPannel == panels.DetailsTab">
    <form #tabForm="ngForm" class="up-form" novalidate>
      <p class="up-hint sc-hint" *ngIf="isEditable">Changes save as soon as you leave a field.</p>

      <!-- Supplier -->
      <div class="up-section">
        <div class="up-section__head">
          <h3 class="up-caption">Supplier</h3>
        </div>
        <div class="up-card">
          <div class="up-row up-row--field" [recordField]="'name'">
            <label class="up-row__label" for="sc-name">Name</label>
            <div class="up-row__value">
              <input id="sc-name" class="sd-input" type="text" name="name" autocomplete="off" required
                     [(ngModel)]="supplier.name" [readonly]="!isEditable"
                     [placeholder]="isEditable ? 'Supplier name' : 'No name'" (change)="saveContactForm('Name')">
            </div>
          </div>

          <div class="up-row">
            <span class="up-row__label sc-label-info">
              Aliases
              <span class="sc-info" tabindex="0" role="img" aria-label="Other names this supplier appears under on documents, so they're matched to it."
                    matTooltip="Other names this supplier appears under on documents, so they're matched to it."
                    matTooltipPosition="above">i</span>
            </span>
            <div class="up-row__value sc-aliases">
              <div class="sc-alias-list" *ngIf="supplier?.aliases?.length">
                <ng-container *ngFor="let alias of supplier.aliases; let i = index">
                  <span class="sc-alias" *ngIf="editingAliasIndex !== i">
                    <button type="button" class="sc-alias__text" [disabled]="!isEditable" [title]="isEditable ? 'Rename' : alias.alias"
                            (click)="isEditable && startEditingAlias(i)">{{ alias.alias }}</button>
                    <button type="button" class="sc-alias__remove" *ngIf="isEditable" title="Remove alias"
                            [attr.aria-label]="'Remove ' + alias.alias" (click)="removeAlias(i); $event.stopPropagation()">
                      <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
                        <path d="M4.5 4.5l7 7M11.5 4.5l-7 7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
                      </svg>
                    </button>
                  </span>
                  <span class="sc-alias-edit" *ngIf="editingAliasIndex === i">
                    <input class="sd-input" type="text" aria-label="Alias" title="Press Enter to save, Escape to cancel"
                           [(ngModel)]="editingAliasValue" [ngModelOptions]="{standalone: true}" (keydown)="handleAliasKeypress($event)">
                    <button type="button" class="sd-icon-btn" aria-label="Save alias" title="Save" (click)="saveEditedAlias()">
                      <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
                        <path d="M3.5 8.5l3 3 6-6.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    </button>
                    <button type="button" class="sd-icon-btn" aria-label="Cancel" title="Cancel" (click)="cancelEditingAlias()">
                      <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
                        <path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
                      </svg>
                    </button>
                  </span>
                </ng-container>
              </div>
              <span class="up-row__empty" *ngIf="!supplier?.aliases?.length && !isEditable">None</span>
              <!-- The existing aliases; the field to add one only once asked for. -->
              <button type="button" class="sc-link-btn" *ngIf="isEditable && !addingAlias" (click)="startAddingAlias()">+ Add alias</button>
              <div class="sc-alias-add" *ngIf="isEditable && addingAlias">
                <input id="sc-new-alias" class="sd-input" type="text" name="newAlias" autocomplete="off" aria-label="New alias"
                       [(ngModel)]="newAlias" placeholder="Another name for this supplier"
                       (keyup.enter)="addAlias()" (keyup.escape)="cancelAddingAlias()">
                <button type="button" class="sd-btn sd-btn--secondary sd-btn--sm" [disabled]="!newAlias?.trim()" (click)="addAlias()">
                  Add
                </button>
                <button type="button" class="sc-link-btn sc-link-btn--muted" (click)="cancelAddingAlias()">Cancel</button>
              </div>
            </div>
          </div>

          <div class="up-row up-row--field" [recordField]="'taxNumber'">
            <label class="up-row__label" for="sc-tax-number">Tax number</label>
            <div class="up-row__value">
              <input id="sc-tax-number" class="sd-input" type="text" name="taxNumber" autocomplete="off"
                     [(ngModel)]="supplier.taxNumber" [readonly]="!isEditable"
                     [placeholder]="isEditable ? 'Tax number' : 'No tax number'" (change)="saveContactForm('Tax Number')">
            </div>
          </div>

          <!-- Matched to a master contact by its website, which brings its logo. -->
          <div class="up-row up-row--field">
            <label class="up-row__label" for="sc-website">Website</label>
            <div class="up-row__value">
              <app-contact-website [contactId]="supplier?.supplierId" kind="supplier" inputId="sc-website"
                                   [editable]="isEditable" (logoChanged)="supplierLogoUrl = $event"></app-contact-website>
            </div>
          </div>

          <div class="up-row up-row--field">
            <label class="up-row__label" for="sc-groups">Groups</label>
            <div class="up-row__value">
              <ng-select class="sd-picker sc-picker" appendTo="body" labelForId="sc-groups" [multiple]="true"
                         [closeOnSelect]="false" [items]="suppliersGroup" bindLabel="typeName"
                         [ngModel]="selectedItems" [ngModelOptions]="{standalone: true}" [disabled]="!isEditable"
                         [placeholder]="isEditable ? 'Add to groups (optional)' : 'No groups'" notFoundText="No groups match"
                         (add)="onItemSelect($event)" (remove)="onDeleteGroup($event.value)" (clear)="onClearGroups()">
              </ng-select>
            </div>
          </div>
        </div>
      </div>

      <!-- Coding defaults -->
      <div class="up-section">
        <div class="up-section__head">
          <h3 class="up-caption">Coding defaults</h3>
        </div>
        <div class="up-card">
          <div class="up-row up-row--field" [recordField]="'defaultAccount'">
            <label class="up-row__label" for="sc-default-account">Account</label>
            <div class="up-row__value">
              <ng-select class="sd-picker sc-picker" appendTo="body" labelForId="sc-default-account" [items]="accounts"
                         bindLabel="name" [clearable]="false" [disabled]="!isEditable"
                         [ngModel]="supplier.defaultAccount?.name ? supplier.defaultAccount : null" [ngModelOptions]="{standalone: true}"
                         [placeholder]="isEditable ? 'Select an account' : 'No account'" notFoundText="No accounts match"
                         (change)="onSelectAccount({ item: $event })">
                <ng-template ng-option-tmp let-item="item">
                  <span class="sd-picker-option">
                    <span class="sd-picker-option__text">
                      <span class="sd-picker-option__title">{{ item.name }}</span>
                      <span class="sd-picker-option__sub" *ngIf="item.displayCode">{{ item.displayCode }}</span>
                    </span>
                  </span>
                </ng-template>
              </ng-select>
            </div>
          </div>

          <div class="up-row up-row--field">
            <label class="up-row__label" for="sc-tax-rate">Tax rate</label>
            <div class="up-row__value">
              <ng-select class="sd-picker sc-picker" appendTo="body" labelForId="sc-tax-rate" [items]="taxRates"
                         bindLabel="name" [compareWith]="isTaxRateNamed" [clearable]="false" [disabled]="!isEditable"
                         [ngModel]="supplier.accountsPayableTaxName || null" [ngModelOptions]="{standalone: true}"
                         [placeholder]="isEditable ? 'Select a tax rate' : 'No tax rate'" notFoundText="No tax rates match"
                         (change)="onSelectTaxRate({ item: $event })">
              </ng-select>
            </div>
          </div>

          <div class="up-row up-row--field" [recordField]="'currency'">
            <label class="up-row__label" for="sc-currency">Currency</label>
            <div class="up-row__value">
              <ng-select class="sd-picker sc-picker" appendTo="body" labelForId="sc-currency" [items]="currencies"
                         [clearable]="false" [disabled]="!isEditable"
                         [(ngModel)]="supplier.currency" [ngModelOptions]="{standalone: true}"
                         [placeholder]="isEditable ? 'Select a currency' : 'No currency'" notFoundText="No currencies match"
                         (change)="saveContactForm('Currency')">
              </ng-select>
            </div>
          </div>
        </div>
      </div>

      <!-- Contact: a summary of who to talk to; Edit (or Add) opens the fields. -->
      <div class="up-section">
        <div class="up-section__head sc-section-head">
          <h3 class="up-caption">Contact</h3>
          <button type="button" class="sc-link-btn" *ngIf="isEditable && !editingContact" (click)="editingContact = true">
            {{ hasContactDetails ? 'Edit' : '+ Add' }}
          </button>
          <button type="button" class="sc-link-btn" *ngIf="editingContact" (click)="editingContact = false">Done</button>
        </div>
        <div class="up-card sc-summary" *ngIf="!editingContact">
          <div class="sc-summary__body" *ngIf="hasContactDetails">
            <span class="sc-summary__title" *ngIf="contactPersonName">{{ contactPersonName }}</span>
            <a class="sc-summary__line" *ngIf="supplier?.email" [href]="'mailto:' + supplier.email">{{ supplier.email }}</a>
          </div>
          <div class="sc-summary__empty" *ngIf="!hasContactDetails">No contact person yet.</div>
        </div>
        <div class="up-card" *ngIf="editingContact">
          <div class="up-row up-row--field">
            <label class="up-row__label" for="sc-first-name">First name</label>
            <div class="up-row__value">
              <input id="sc-first-name" class="sd-input" type="text" name="firstName" autocomplete="off"
                     [(ngModel)]="supplier.firstName" [readonly]="!isEditable"
                     [placeholder]="isEditable ? 'First name' : 'No first name'" (change)="saveContactForm('First Name')">
            </div>
          </div>
          <div class="up-row up-row--field">
            <label class="up-row__label" for="sc-last-name">Last name</label>
            <div class="up-row__value">
              <input id="sc-last-name" class="sd-input" type="text" name="lastName" autocomplete="off"
                     [(ngModel)]="supplier.lastName" [readonly]="!isEditable"
                     [placeholder]="isEditable ? 'Last name' : 'No last name'" (change)="saveContactForm('Last Name')">
            </div>
          </div>
          <div class="up-row up-row--field" [recordField]="'email'">
            <label class="up-row__label" for="sc-email">Email</label>
            <div class="up-row__value">
              <input id="sc-email" class="sd-input" type="email" name="email" autocomplete="off" email
                     [(ngModel)]="supplier.email" [readonly]="!isEditable"
                     [placeholder]="isEditable ? 'name@company.com' : 'No email'" (change)="saveContactForm('Email')">
            </div>
          </div>
        </div>
      </div>

      <!-- Payment: a summary of where payments go; Edit (or Add) opens the fields. -->
      <div class="up-section">
        <div class="up-section__head sc-section-head">
          <h3 class="up-caption">Payment details</h3>
          <button type="button" class="sc-link-btn" *ngIf="isEditable && !editingPayment" (click)="editingPayment = true">
            {{ hasPaymentDetails ? 'Edit' : '+ Add' }}
          </button>
          <button type="button" class="sc-link-btn" *ngIf="editingPayment" (click)="editingPayment = false">Done</button>
        </div>
        <div class="up-card sc-summary" *ngIf="!editingPayment">
          <div class="sc-summary__body" *ngIf="hasPaymentDetails">
            <span class="sc-summary__title">Bank transfer</span>
            <span class="sc-summary__line" *ngIf="countryCode != 'US'">
              <ng-container *ngIf="bankAccount?.branchDetails">BSB {{ bankAccount.branchDetails }}</ng-container>
              <ng-container *ngIf="bankAccount?.branchDetails && bankAccount?.accountNumber"> · </ng-container>
              <ng-container *ngIf="bankAccount?.accountNumber">Acct {{ maskedAccount(bankAccount.accountNumber) }}</ng-container>
            </span>
            <span class="sc-summary__line" *ngIf="countryCode == 'US'">
              <ng-container *ngIf="bankAccount?.routingNumber">Routing {{ bankAccount.routingNumber }}</ng-container>
              <ng-container *ngIf="bankAccount?.routingNumber && bankAccount?.accountNumberUS"> · </ng-container>
              <ng-container *ngIf="bankAccount?.accountNumberUS">Acct {{ maskedAccount(bankAccount.accountNumberUS) }}</ng-container>
            </span>
            <span class="sc-summary__meta" *ngIf="bankName">{{ bankName }}</span>
          </div>
          <div class="sc-summary__empty" *ngIf="!hasPaymentDetails">No bank details yet.</div>
        </div>
        <div class="up-card" *ngIf="editingPayment">
          <div class="up-row up-row--field">
            <label class="up-row__label" for="sc-payment-method">Method</label>
            <div class="up-row__value">
              <select id="sc-payment-method" class="sd-input sc-select" name="paymentDetails" [disabled]="!isEditable"
                      title="Payment Details">
                <option *ngFor="let type of paymentMethods" [ngValue]="type.key">
                  {{type.text}}
                </option>
              </select>
            </div>
          </div>

          <ng-container *ngIf="countryCode != 'US'">
            <div class="up-row up-row--field" [recordField]="'bsb'">
              <label class="up-row__label" for="sc-bsb">BSB</label>
              <div class="up-row__value">
                <input id="sc-bsb" class="sd-input" type="text" name="BSB" #tabBsb="ngModel" autocomplete="off"
                       pattern="\d{3}-\d{3}" [ngModel]="bankAccount.branchDetails" [readonly]="!isEditable"
                       [placeholder]="isEditable ? '000-000' : 'No BSB'"
                       [class.is-invalid]="tabBsb.invalid && (tabBsb.dirty || tabBsb.touched)"
                       (ngModelChange)="updateBSB($event)" (change)="saveBSBAccountPair()">
                <span class="sd-field__error" *ngIf="tabBsb.errors?.pattern && (tabBsb.dirty || tabBsb.touched)">
                  Enter the BSB as six digits: XXX-XXX
                </span>
                <span class="up-row__meta" *ngIf="bankName">{{ bankName }}</span>
              </div>
            </div>
            <div class="up-row up-row--field" [recordField]="'bankAccountNumber'">
              <label class="up-row__label" for="sc-account-number">Account no.</label>
              <div class="up-row__value">
                <input id="sc-account-number" class="sd-input" type="text" name="accountNumber" #tabAccountNumber="ngModel"
                       autocomplete="off" pattern="\d+" [(ngModel)]="bankAccount.accountNumber" [readonly]="!isEditable"
                       [placeholder]="isEditable ? 'Account number' : 'No account number'"
                       [class.is-invalid]="tabAccountNumber.invalid && (tabAccountNumber.dirty || tabAccountNumber.touched)"
                       (change)="saveBSBAccountPair()">
                <span class="sd-field__error" *ngIf="tabAccountNumber.errors?.pattern && (tabAccountNumber.dirty || tabAccountNumber.touched)">
                  Use numbers only
                </span>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="countryCode == 'US'">
            <div class="up-row up-row--field">
              <label class="up-row__label" for="sc-routing">Routing no.</label>
              <div class="up-row__value">
                <input id="sc-routing" class="sd-input" type="text" name="Routing" #tabRouting="ngModel" autocomplete="off"
                       pattern="\d{9}" maxlength="9" [ngModel]="bankAccount.routingNumber" [readonly]="!isEditable"
                       [placeholder]="isEditable ? '9 digits' : 'No routing number'"
                       [class.is-invalid]="tabRouting.invalid && (tabRouting.dirty || tabRouting.touched)"
                       (ngModelChange)="updateRouting($event)" (change)="saveRoutingAccountPair()" (keypress)="numberOnly($event)">
                <span class="sd-field__error" *ngIf="tabRouting.errors?.pattern && (tabRouting.dirty || tabRouting.touched)">
                  Enter the routing number as nine digits
                </span>
              </div>
            </div>
            <div class="up-row up-row--field" [recordField]="'bankAccountNumber'">
              <label class="up-row__label" for="sc-account-number-us">Account no.</label>
              <div class="up-row__value">
                <input id="sc-account-number-us" class="sd-input" type="text" name="accountNumberUS" #tabAccountNumberUS="ngModel"
                       autocomplete="off" pattern="\d+" [(ngModel)]="bankAccount.accountNumberUS" [readonly]="!isEditable"
                       [placeholder]="isEditable ? 'Account number' : 'No account number'"
                       [class.is-invalid]="tabAccountNumberUS.invalid && (tabAccountNumberUS.dirty || tabAccountNumberUS.touched)"
                       (change)="saveRoutingAccountPair()">
                <span class="sd-field__error" *ngIf="tabAccountNumberUS.errors?.pattern && (tabAccountNumberUS.dirty || tabAccountNumberUS.touched)">
                  Use numbers only
                </span>
              </div>
            </div>
          </ng-container>
          <div class="up-row up-row--note" *ngIf="isEditable">
            Bank details save once both {{ countryCode == 'US' ? 'numbers are' : 'the BSB and account number are' }} filled in and valid.
          </div>
        </div>
      </div>
    </form>
  </section>

  <app-contact-expenses
    *ngIf="currentPannel == panels.ExpensesTab"
    [supplier]="supplier"
    [billsToPayMode]="billsToPayMode"
    (clickInvoiceEvent)="clickOnRelatedInvoice($event)">
  </app-contact-expenses>

  <app-contact-activity *ngIf="currentPannel == panels.ActivityTab" [supplier]="supplier"></app-contact-activity>

  <app-related-contact
    *ngIf="currentPannel == panels.RelatedTab"
    [billsToPayMode]="billsToPayMode"
    [supplier]="supplier"
    (clickInvoiceEvent)="clickOnRelatedInvoice($event)">
  </app-related-contact>

  <!-- An approval asked of (or by) the viewer on this supplier, at the foot of the panel. -->
  <div class="sc-approval" [class.sc-approval--active]="approvalActive"
       *ngIf="currentPannel != panels.InvoiceDetailsTab && reviewRecordIds.length">
    <app-approval-block recordType="supplier" [recordIds]="reviewRecordIds" (activeChange)="approvalActive = $event">
    </app-approval-block>
  </div>

  <!-- A bill opened from the Expenses or Related tab, shown in place of the tabs. -->
  <div class="contact-invoice-detail" *ngIf="currentPannel == panels.InvoiceDetailsTab">
    <app-upload-invoice-form
      [isEditable]="false"
      [billsToPayMode]="true"
      [hexColorClass]="supplier?.hexColorClass"
      (closeFormOnBillsToPayEvent)="backToExpenses()">
    </app-upload-invoice-form>
  </div>
</div>

<!-- The contact form inside the invoice upload form (supplierTabMode off): its original design. -->
<ng-template #legacyPanel>
<div class="contact-container">
  <div class="back-area" *ngIf="!supplierTabMode && currentPannel != panels.InvoiceDetailsTab" (click)="cancel()">
    <div class="shevron">
      <img src="../../../../../assets/img/invoiceForm/shevron-white.svg" alt="">
    </div>
    <div class="text">Back to Invoice</div>
  </div>

  <section class="controls-panel" *ngIf="currentPannel != panels.InvoiceDetailsTab">
    <div class="logo-container">
      <!-- <div class="logo" [ngClass]="{'sup_img_box_1': invoiceColorNumber == 1,'sup_img_box_2': invoiceColorNumber == 2,'sup_img_box_3': invoiceColorNumber ==3,'sup_img_box_4': invoiceColorNumber == 4,'sup_img_box_5': invoiceColorNumber == 5,'sup_img_box_6': invoiceColorNumber == 6}">
        <span>{{supplier.name | shortLogo}}</span>
      </div> -->
      <app-supplier-avatar class="logo {{supplier.hexColorClass}}" [name]="supplier.name" [logoUrl]="supplierLogoUrl">
        <span>{{supplier.name | shortLogo}}</span>
      </app-supplier-avatar>
    </div>
    <div class="title">
      <span>{{supplier.name}}</span>
    </div>
    <div class="control" *ngIf="false">
      <img class="icon-left" matTooltip="Move back" [matTooltipShowDelay]="showToolTipDelay" (click)="cancel()"
        src="../../../../../assets/img/invoiceForm/arrow-left.svg"/>
    </div>
    <div class="close-icon" matTooltip="Hide Side Bar" [matTooltipShowDelay]="showToolTipDelay"
      (click)="closeFormOnSupplier()" *ngIf="supplierTabMode">
        <img src="../../../../../assets/img/close-icon.svg" alt="">
    </div>
  </section>

  <section class="tab-header" *ngIf="currentPannel != panels.InvoiceDetailsTab">
    <div class="_tab" *ngIf="supplierTabMode || supplier?.supplierId" [ngClass]="currentPannel == panels.ExpensesTab ? 'active' : ''" (click)="tabClick(panels.ExpensesTab)">
      <div class="tab-inner">
        <div class="caption">Transactions</div>
        <div class="underline"></div>
      </div>
    </div>
    <div class="_tab" [ngClass]="currentPannel == panels.DetailsTab ? 'active' : ''" (click)="tabClick(panels.DetailsTab)">
      <div class="tab-inner">
        <div class="caption">Details</div>
        <div class="underline"></div>
      </div>
    </div>
    <div class="_tab" [ngClass]="currentPannel == panels.ActivityTab ? 'active' : ''" (click)="tabClick(panels.ActivityTab)">
      <div class="tab-inner">
        <div class="caption">Activity</div>
        <div class="underline"></div>
      </div>
    </div>
    <div class="_tab" [ngClass]="currentPannel == panels.RelatedTab ? 'active' : ''" (click)="tabClick(panels.RelatedTab)">
      <div class="tab-inner">
        <div class="caption">Related</div>
        <div class="underline"></div>
      </div>
    </div>
  </section>


  <section class="content" *ngIf="currentPannel == panels.DetailsTab" [ngStyle]="{'height': !supplierTabMode ? 'calc(100vh - 137px - 81px)' : '100%', 'overflow-y': !supplierTabMode ? 'auto' : 'hidden'}">
    <form #form="ngForm">
      <!-- Supplier -->
      <div class="form-group">
        <div class="field-label">Name</div>
        <div class="field-input">
          <input [(ngModel)]="supplier.name" name="name" class="frm-input" type="text" [ngClass]="isEditable ? 'control-active' : ''"
                 [placeholder]="isEditable ? 'Input Supplier Name' : 'No Supplier Name'" required (change)="saveContactForm('Name')" [readonly]="!isEditable">
        </div>
      </div>

      <!-- Alias -->
      <div class="form-group alias-group" [ngClass]="{'expanded': isEditable || editingField.alias}">
        <div class="field-label">Alias</div>
        <div class="field-input">
          <!-- View Mode -->
          <div class="alias-list" *ngIf="!isEditable && !editingField.alias" (click)="editingField.alias = true">
            <div *ngIf="!supplier?.aliases?.length" class="no-aliases">No aliases</div>
            <div *ngIf="supplier?.aliases?.length" class="alias-pills">
              <div *ngFor="let alias of supplier.aliases" class="alias-pill">
                {{alias.alias}}
              </div>
            </div>
          </div>
          
          <!-- Edit Mode -->
          <div class="alias-edit" *ngIf="isEditable || editingField.alias">
            <div class="alias-pills" *ngIf="supplier?.aliases?.length > 0">
              <div *ngFor="let alias of supplier.aliases; let i = index" class="alias-pill" [class.editing]="editingAliasIndex === i">
                <!-- View Mode -->
                <ng-container *ngIf="editingAliasIndex !== i">
                  <span (click)="isEditable && startEditingAlias(i)" 
                        [class.editable]="isEditable" 
                        [matTooltip]="isEditable ? 'Click to edit' : ''"
                        [matTooltipShowDelay]="showToolTipDelay">
                    <span class="alias-text">{{alias.alias}}</span>
                    <i class="fas fa-pencil edit-icon" *ngIf="isEditable"></i>
                  </span>
                  <button type="button" 
                          class="btn-remove" 
                          (click)="removeAlias(i); $event.stopPropagation()" 
                          matTooltip="Remove alias"
                          [matTooltipShowDelay]="showToolTipDelay"
                          *ngIf="isEditable">
                    <i class="fas fa-times"></i>
                  </button>
                </ng-container>
                <!-- Edit Mode -->
                <ng-container *ngIf="editingAliasIndex === i">
                  <div class="edit-container">
                    <input [(ngModel)]="editingAliasValue"
                           [ngModelOptions]="{standalone: true}"
                           class="edit-input"
                           (keydown)="handleAliasKeypress($event)"
                           placeholder="Edit alias"
                           title="Press Enter to save, Escape to cancel"
                           #editInput>
                    <div class="edit-actions">
                      <button type="button" 
                              class="btn-save-edit" 
                              (click)="saveEditedAlias()"
                              matTooltip="Save changes"
                              [matTooltipShowDelay]="showToolTipDelay">
                        <i class="fas fa-check"></i>
                      </button>
                      <button type="button" 
                              class="btn-cancel-edit" 
                              (click)="cancelEditingAlias()"
                              matTooltip="Cancel editing"
                              [matTooltipShowDelay]="showToolTipDelay">
                        <i class="fas fa-times"></i>
                      </button>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
            <div class="add-alias-form" *ngIf="isEditable">
              <div class="input-with-button">
                <input [(ngModel)]="newAlias" 
                       name="newAlias" 
                       class="frm-input" 
                       type="text" 
                       [placeholder]="'Add ' + (!supplier?.aliases?.length ? 'an' : 'another') + ' alias'"
                       (keyup.enter)="addAlias()"
                       title="Type a new alias">
                <button type="button" 
                        class="btn-add"
                        (click)="addAlias()"
                        [disabled]="!newAlias?.trim()"
                        [class.visible]="newAlias?.trim()"
                        title="Add alias">
                  <i class="fas fa-check"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Tax Number -->
      <div class="form-group">
        <div class="field-label">Tax Number</div>
        <div class="field-input">
          <input [(ngModel)]="supplier.taxNumber" name="taxNumber" class="frm-input" type="text" [ngClass]="isEditable ? 'control-active' : ''"
                 [placeholder]="isEditable ? 'Input Tax Number' : 'No Tax Number'" (change)="saveContactForm('Tax Number')" [readonly]="!isEditable">
        </div>
      </div>

      <!-- Groups -->
      <div class="form-group margin-bottom">
        <div class="field-label group-label">Groups</div>
        <div class="field-input">
          <ng-multiselect-dropdown [placeholder]="isEditable ? 'Select Contact Group (optional)' : 'No Contact Group'"
                                   [settings]="dropdownSettings"
                                   [data]="suppliersGroup"
                                   [(ngModel)]="selectedItems"
                                   (onSelect)="onItemSelect($event)"
                                   (onSelectAll)="onSelectAll($event)"
                                   (onDeSelect)="onDeleteGroup($event)"
                                   name="suppliersGroup"
                                   class="custom_mat_select"
                                   [ngClass]="isEditable ? 'active' : ''">
          </ng-multiselect-dropdown>

        </div>
      </div>

      <!-- Default Account -->
      <div class="form-group">
        <div class="field-label">Default Account</div>
        <div class="field-input">
          <input [ngModel]="supplier.defaultAccount.name"
                 [typeahead]="accounts"
                 typeaheadOptionField="name"
                 [typeaheadScrollable]=true
                 (typeaheadOnSelect)="onSelectAccount($event)"
                 [typeaheadOptionsInScrollableView]="10"
                 [typeaheadMinLength]="0"
                 [typeaheadOptionsLimit]="accounts.length"
                 class="default_account"
                 [placeholder]="isEditable ? 'Select Account' : 'No Account'"
                 [ngModelOptions]="{standalone: true}"
                 namw="defaultAccount"
                 [disabled]="!isEditable"
                 [ngClass]="isEditable ? 'control-active default_account_active' : ''">
        </div>
      </div>

      <!-- Default Tax Rate -->
      <div class="form-group">
        <div class="field-label">Default Tax Rate</div>
        <div class="field-input">
          <input [ngModel]="supplier.accountsPayableTaxName"
                 [typeahead]="taxRates"
                 typeaheadOptionField="name"
                 [typeaheadScrollable]=true
                 (typeaheadOnSelect)="onSelectTaxRate($event)"
                 [typeaheadOptionsInScrollableView]="10"
                 [typeaheadMinLength]="0"
                 [typeaheadOptionsLimit]="taxRates.length"
                 class="default_account"
                 [placeholder]="isEditable ? 'Select Tax Rate' : 'No Rate'"
                 [ngModelOptions]="{standalone: true}" 
                 [disabled]="!isEditable"
                 [ngClass]="isEditable ? 'control-active default_account_active' : ''">
        </div>
      </div>

      <!-- Default Currency -->
      <div class="form-group">
        <div class="field-label">Default Currency</div>
        <div class="field-input">
          <input [(ngModel)]="supplier.currency"
                 [typeahead]="currencies"
                 [typeaheadScrollable]=true
                 [typeaheadOptionsInScrollableView]="10"
                 [typeaheadOptionsLimit]="currencies?.length"
                 [typeaheadMinLength]="isEditable ? 0 : 1"
                 class="default_account"
                 [placeholder]="isEditable ? 'Select Currency' : 'No Currency'"
                 [ngModelOptions]="{standalone: true}"
                 [disabled]="!isEditable"
                 [ngClass]="isEditable ? 'control-active default_account_active' : ''"
                 (typeaheadOnSelect)="saveContactForm('Currency')">
        </div>
      </div>

      <!-- Contact -->
      <div class="form-group">
        <div class="field-label">Contact</div>
        <div class="field-input">
          <input [(ngModel)]="supplier.firstName" name="firstName" class="frm-input contact" type="text" [ngClass]="isEditable ? 'control-active' : ''"
                 [placeholder]="isEditable ? 'Add First Name' : 'No First Name'" (change)="saveContactForm('First Name')" [readonly]="!isEditable">
          <input [(ngModel)]="supplier.lastName" name="lastName" class="frm-input contact" type="text" [ngClass]="isEditable ? 'control-active' : ''"
                 [placeholder]="isEditable ? 'Add Last Name' : 'No Last Name'" (change)="saveContactForm('Last Name')" [readonly]="!isEditable">
          <input [(ngModel)]="supplier.email" name="email" class="frm-input contact" type="email" [placeholder]="isEditable ? 'Add Email' : 'No Email'" [ngClass]="isEditable ? 'control-active' : ''"
                 email (change)="saveContactForm('Email')" [readonly]="!isEditable">
        </div>
      </div>

      <!-- Payment -->
      <section class="payment">
        <div class="top-line"></div>
        <div class="payment-title">Payment Default</div>
        <div class="form-group">
          <div class="field-label">Method</div>
          <div class="field-input">
            <select class="form-control form-select" 
                  name="paymentDetails" 
                  [disabled]="!isEditable"
                  title="Payment Details"
                  aria-label="Payment Details">
              <option *ngFor="let type of paymentMethods" [ngValue]="type.key">
                {{type.text}}
              </option>
            </select>
          </div>
        </div>
        <div class="form-group" *ngIf="countryCode != 'US'">
          <div class="field-label">BSB</div>
          <div class="field-input">
            <span class="name">{{bankName}}</span>
            <input [ngModel]="bankAccount.branchDetails" 
                   name="BSB" 
                   #BSB="ngModel" 
                   class="form-control form-input" 
                   type="text"
                   title="BSB Number"
                   aria-label="BSB Number"
                   pattern="\d{3}-\d{3}" [placeholder]="isEditable ? 'Enter BSB' : 'No BSB'" autocomplete="off" (ngModelChange)="updateBSB($event)"
                   (change)="saveBSBAccountPair()" [readonly]="!isEditable" [ngClass]="isEditable ? 'control-active' : ''">
            <div *ngIf="BSB.invalid && (BSB.dirty || BSB.touched)" class="error-message">
              <div *ngIf="BSB.errors?.pattern">
                BSB must be 6 digits long and have the following format: XXX-XXX.
              </div>
            </div>
          </div>
        </div>
        <div class="form-group" *ngIf="countryCode != 'US'">
          <div class="field-label">Account No.</div>
          <div class="field-input account-number">
            <input [(ngModel)]="bankAccount.accountNumber" 
                   name="accountNumber" 
                   class="form-control form-input" 
                   type="text"
                   title="Account Number"
                   aria-label="Account Number"
                   pattern="\d+" #accountNumber="ngModel" [placeholder]="isEditable ? 'Enter Account #' : 'No Account #'" autocomplete="off"
                   (change)="saveBSBAccountPair()" [readonly]="!isEditable" [ngClass]="isEditable ? 'control-active' : ''">
            <div *ngIf="accountNumber.invalid && (accountNumber.dirty || accountNumber.touched)" class="error-message">
              <div *ngIf="accountNumber.errors?.pattern">
                Account number must contain only numbers.
              </div>
            </div>
          </div>
        </div>

        <div class="form-group" *ngIf="countryCode == 'US'">
          <div class="field-label">Routing No.</div>
          <div class="field-input">
            <input [ngModel]="bankAccount.routingNumber" 
                   name="Routing" 
                   #Routing="ngModel" 
                   class="form-control form-input" 
                   type="text"
                   title="Routing Number"
                   aria-label="Routing Number"
                   pattern="\d{9}" [placeholder]="isEditable ? 'Enter Routing Number' : 'No Routing Number'" autocomplete="off" (ngModelChange)="updateRouting($event)"
                   (change)="saveRoutingAccountPair()" (keypress)="numberOnly($event)" maxlength="9" [readonly]="!isEditable" [ngClass]="isEditable ? 'control-active' : ''">
            <div *ngIf="Routing.invalid && (Routing.dirty || Routing.touched)" class="error-message">
              <div *ngIf="Routing.errors?.pattern">
                Routing must be 9 digits long and have the following format: XXXXXXXXX.
              </div>
            </div>
          </div>
        </div>
        <div class="form-group" *ngIf="countryCode == 'US'">
          <div class="field-label">Account No.</div>
          <div class="field-input account-number">
            <input [(ngModel)]="bankAccount.accountNumberUS" 
                   name="accountNumberUS" 
                   class="form-control form-input" 
                   type="text"
                   title="US Account Number"
                   aria-label="US Account Number"
                   pattern="\d+" #accountNumberUS="ngModel" [placeholder]="isEditable ? 'Enter Account #' : 'No Account #'" autocomplete="off"
                   (change)="saveRoutingAccountPair()" [readonly]="!isEditable" [ngClass]="isEditable ? 'control-active' : ''">
            <div *ngIf="accountNumberUS.invalid && (accountNumberUS.dirty || accountNumberUS.touched)" class="error-message">
              <div *ngIf="accountNumberUS.errors?.pattern">
                Account number must contain only numbers.
              </div>
            </div>
          </div>
        </div>
      </section>
      <button class="btn-save" 
              id="saveContactFormButton" 
              type="button"
              title="Save BSB and Account Number"
              aria-label="Save BSB and Account Number"
              (click)="submit('BSB and Account Number')">
              <span class="visually-hidden">Save BSB and Account Number</span>
      </button>
    </form>
  </section>
  
  <!-- Expenses Panel -->
  <app-contact-expenses
    *ngIf="currentPannel == panels.ExpensesTab"
    [supplier]="supplier"
    [billsToPayMode]="billsToPayMode"
    (clickInvoiceEvent)="clickOnRelatedInvoice($event)">
  </app-contact-expenses>

  <!-- Activity Panel — Direction C: segmented Activity timeline + Notes conversation -->
  <app-contact-activity *ngIf="currentPannel == panels.ActivityTab" [supplier]="supplier"></app-contact-activity>

  <!-- Related Panel -->
  <app-related-contact
    *ngIf="currentPannel == panels.RelatedTab"
    [billsToPayMode]="billsToPayMode"
    [supplier]="supplier"
    (clickInvoiceEvent)="clickOnRelatedInvoice($event)">
  </app-related-contact>

  <!-- Invoice Detail Panel - drill into a bill from the Expenses / Related tab in place.
       Wrapped in a flex/scroll container that mirrors the Bills-to-pay sidebar host
       (.sidepanel-stacked) so the embedded form sizes the same way it does there. -->
  <div class="contact-invoice-detail" *ngIf="currentPannel == panels.InvoiceDetailsTab">
    <app-upload-invoice-form
      [isEditable]="false"
      [billsToPayMode]="true"
      [hexColorClass]="supplier?.hexColorClass"
      (closeFormOnBillsToPayEvent)="backToExpenses()">
    </app-upload-invoice-form>
  </div>
</div>
</ng-template>

<style>
  /* ... existing styles ... */

  /* Bill detail drilled into from the Expenses / Related tab.
     Mirrors the Bills-to-pay sidebar host (.sidepanel-stacked / __body) so the
     embedded app-upload-invoice-form gets the same width + scroll context it
     relies on, instead of stretching inside the wider contact panel. */
  .contact-invoice-detail {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    max-width: 461px;
  }

  .contact-invoice-detail > app-upload-invoice-form {
    display: block;
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
  }

  /* Alias Group Styles */
  .alias-group .no-aliases {
    color: #999;
    font-style: italic;
    padding: 6px 0;
  }

  .alias-group .alias-pills {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 4px 0;
  }

  .alias-group .alias-pill {
    display: inline-flex;
    align-items: center;
    background-color: #f0f0f0;
    border: 1px solid #e0e0e0;
    border-radius: 16px;
    padding: 4px 12px;
    font-size: 13px;
    color: #555;
    line-height: 1.2;
    transition: all 0.2s ease;
  }

  .alias-group .alias-edit .alias-pill {
    padding-right: 8px;
  }

  .alias-group .alias-pill .btn-remove {
    background: none;
    border: none;
    color: #999;
    font-size: 16px;
    width: 20px;
    height: 20px;
    padding: 0;
    margin-left: 4px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.2s ease;
  }

  .alias-group .alias-pill .btn-remove:hover {
    background-color: rgba(0, 0, 0, 0.05);
    color: #666;
  }

  .alias-group .alias-list {
    cursor: pointer;
  }

  .alias-group .add-alias-form {
    margin-top: 8px;
  }

  .alias-group .add-alias-form .input-with-button {
    display: flex;
    gap: 8px;
    align-items: center;
  }

  .alias-group .add-alias-form .frm-input {
    flex: 1;
    font-size: 14px;
    padding: 6px 12px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    transition: all 0.2s ease;
  }

  .alias-group .add-alias-form .frm-input:focus {
    border-color: #666;
    outline: none;
  }

  .alias-group .add-alias-form .btn-add {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 6px 12px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .alias-group .add-alias-form .btn-add:hover:not(:disabled) {
    background-color: #0056b3;
  }

  .alias-group .add-alias-form .btn-add:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }

  .alias-group .add-alias-form .btn-add i {
    font-size: 12px;
  }

  /* Hover effects */
  .alias-group .alias-pill:hover {
    background-color: #e8e8e8;
    border-color: #d8d8d8;
  }

  .alias-group .alias-pill .editable {
    cursor: pointer;
  }

  .alias-group .alias-pill .editable {
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }

  .alias-group .alias-pill .edit-icon {
    font-size: 11px;
    opacity: 0;
    transition: opacity 0.2s ease;
    color: #666;
  }

  .alias-group .alias-pill:hover .edit-icon {
    opacity: 1;
  }

  .alias-group .alias-pill.editing {
    padding: 2px;
    min-width: 150px;
  }

  .alias-group .alias-pill .edit-container {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
  }

  .alias-group .alias-pill .edit-input {
    background: transparent;
    border: none;
    border-bottom: 1px solid #ccc;
    outline: none;
    padding: 2px 8px;
    font-size: 13px;
    flex: 1;
  }

  .alias-group .alias-pill .edit-input:focus {
    border-bottom-color: #666;
  }

  .alias-group .alias-pill .edit-actions {
    display: flex;
    gap: 4px;
  }

  .alias-group .alias-pill .btn-save-edit,
  .alias-group .alias-pill .btn-cancel-edit {
    background: none;
    border: none;
    width: 20px;
    height: 20px;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  .alias-group .alias-pill .btn-save-edit {
    color: #28a745;
  }

  .alias-group .alias-pill .btn-cancel-edit {
    color: #dc3545;
  }

  .alias-group .alias-pill .btn-save-edit:hover {
    background-color: rgba(40, 167, 69, 0.1);
  }

  .alias-group .alias-pill .btn-cancel-edit:hover {
    background-color: rgba(220, 53, 69, 0.1);
  }
</style>
